import { useState } from "react";
import PropTypes from 'prop-types';

// import Header from "./Header"
import Sidebar from "./Sidebar";

export const Layout = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        {/* <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} /> */}

        <main>
          <div className="h-screen bg-primary">{props.children} </div>
        </main>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.element
}
